import { ArrowUp, ArrowDown } from "react-feather";
import {SortWrapper, Label, Icons} from "./styles";

export const SortIndicator = ({ label, sortDirection, onClick }) => {
  return (
    <SortWrapper onClick={onClick}>
      <Label>{label}</Label>
      <Icons>
        <ArrowUp
          size={16}
          color={sortDirection === "asc" ? "#000000" : "#9CA3AF"}
        />
        <ArrowDown
          size={16}
          color={sortDirection === "desc" ? "#000000" : "#9CA3AF"}
        />
      </Icons>
    </SortWrapper>
  );
};